
import Vue from "vue";
import EditSvgIcon from "@/assets/icons/edit.svg";

export default Vue.extend({
  components: {
    EditSvgIcon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  }
});
